import TopicTwo from "../client-protection-contents/TopicOne";

const ClientProtectionContentThree = () => {
  return (
    <>
      <TopicTwo />

      <div className="how__work__trading">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>Encrypted Deposits & Withdrawals</h3>
                <p>
                  Every transaction you make, whether funding your account or
                  requesting a withdrawal, is protected with industry-standard
                  encryption. This ensures that your payment details, bank
                  information, and transaction data remain completely secure
                  throughout the process.
                </p>

                <h3>Verified Account Ownership</h3>
                <p>
                  To prevent unauthorised access or fraudulent activity, all
                  payment actions undergo mandatory identity and
                  account-ownership checks. Only you can request movement of
                  funds, and our systems immediately flag inconsistencies for
                  further verification.
                </p>

                {/* <h3>Secure Banking Partners & Gateways</h3>
                <p>
                  We work exclusively with trusted, regulated banking providers
                  and secure global payment gateways. This minimises risk,
                  ensures full traceability of funds, and provides fast,
                  reliable processing across all supported payment methods.
                </p>

                <h3>Real-Time Monitoring & Fraud Prevention</h3>
                <p>
                  Our security systems continuously scan for unusual transaction
                  patterns, sudden withdrawals, or irregular funding attempts.
                  Suspicious activity is paused and reviewed instantly, giving
                  you an extra layer of protection and helping prevent financial
                  loss before it occurs.
                </p> */}
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/trading/client_protection/client_protection_2.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientProtectionContentThree;
